import Content from "../../../../layout/Content";
import JobHeader from "./JobHeader";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCalendarAlt, faCode } from "@fortawesome/free-solid-svg-icons";
import { btn, btnHoverStyle } from "../../../../layout/Buttons/buttonStyles";
import JobConfig from "@serie3/freelancesplaceapi/Config/Projects/JobConfig";
import crudApi from "@serie3/common/api/crudApi";
import { useNavigate } from "react-router-dom";
import CompleteDropdown from "../../../../layout/Dropdowns/CompleteDropdown";
import listHandler from "@serie3/common/Domain/listHandler";
import JobView from "./JobView";
import getSettings from "@serie3/common/config/settings";
import PaymentModal from "../../../../layout/Payment/PaymentModal";

const Index = () => {
  const [jobs, setJobs] = useState([]);
  const [showRowError, setShowRowError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showView, setShowView] = useState(false);
  const [viewJob, setViewJob] = useState();
  const [showPayModal, setShowPayModal] = useState(false);
  const [settings, setSettings] = useState();

  const navigate = useNavigate();

  const createNew = async () => {
    const response = await crudApi.createNew(JobConfig.endpoints.new, { jobtitle: " " }, setShowPayModal);
    if (response.status === 200) {
      navigate(JobConfig.endpoints.edit + "/" + response.data.id);
    } else {
      setShowRowError(true);
    }
  };

  const NewButton = () => (
    <>
      <style>{btnHoverStyle}</style>
      <button className="btn-modern" style={{ ...btn.base, ...btn.primary }} onClick={createNew}>
        <FontAwesomeIcon icon={faPlus} /> New Job
      </button>
    </>
  );

  const editAction = (id) => navigate(JobConfig.endpoints.edit + "/" + id);

  const deleteAction = async (index, job) => {
    listHandler.deleteFromList(
      index,
      crudApi.del(JobConfig.endpoints.delete, job.id),
      setJobs,
      jobs,
      setShowRowError
    );
  };

  const viewAction = (job) => {
    setViewJob(job);
    setShowView(true);
  };

  useEffect(() => {
    crudApi.getAll(JobConfig.endpoints.getAll, setJobs, "job");
    setSettings(getSettings());
    setIsLoaded(true);
  }, []);

  const title = () => "Outsource Jobs";

  return isLoaded ? (
    <>
      {settings && <PaymentModal show={showPayModal} setShow={setShowPayModal} priceTableId={settings.pricingTables.jobs} />}
      <JobView job={viewJob} showView={showView} setShowView={setShowView} />
      <JobHeader />
      <Content Title={title} AdditionalButtons={NewButton}>
        {jobs.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "#9e9e9e", fontSize: "0.95rem" }}>
            No jobs yet. Post your first outsourcing job!
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "4px 0" }}>
            {jobs.map((job, index) => (
              <JobRow
                key={index}
                job={job}
                editAction={() => editAction(job.id)}
                deleteAction={() => deleteAction(index, job)}
                viewAction={() => viewAction(job)}
              />
            ))}
          </div>
        )}
      </Content>
    </>
  ) : null;
};

const JobRow = ({ job, editAction, deleteAction, viewAction }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={viewAction}
      style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: hovered ? "0 4px 20px rgba(0,0,0,0.12)" : "0 1px 6px rgba(0,0,0,0.07)",
        borderLeft: "4px solid #f57c00",
        padding: "16px 20px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        transition: "box-shadow 0.15s, transform 0.1s",
        transform: hovered ? "translateY(-1px)" : "none",
        cursor: "pointer",
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: "1rem", color: "#212121", marginBottom: "6px" }}>
          {job.jobtitle}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#9e9e9e", fontSize: "0.8rem", marginBottom: job.languages?.length ? "8px" : 0 }}>
          <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: "0.7rem" }} />
          <span>Starting: {job.start || "—"}</span>
        </div>
        {job.languages?.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
            {job.languages.map((lang, i) => (
              <span key={i} style={{
                display: "inline-flex", alignItems: "center", gap: "4px",
                padding: "2px 8px", borderRadius: "20px", fontSize: "0.72rem",
                fontWeight: 600, background: "#e8f5e9", color: "#2e7d32",
              }}>
                <FontAwesomeIcon icon={faCode} style={{ fontSize: "0.65rem" }} />
                {lang.name}
              </span>
            ))}
          </div>
        )}
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        <CompleteDropdown editAction={editAction} deleteAction={deleteAction} viewAction={viewAction} />
      </div>
    </div>
  );
};

export default Index;
